var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container tw-text-[31px] tw-text-[#8cabcb] group-hover:tw-text-blue tw-absolute tw-left-[17px] tw-top-0 tw-bottom-0 tw-flex tw-items-center tw-m-auto "},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }